// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gV","h5Button":"gV","button":"gW","block":"gX","btnDefault":"gY","disable":"gZ","btnPrimary":"g0"};